import { TourConfig, TourHandle, useFeatureTour } from '@app/core/tours/useFeatureTour';
import { defineMessage, useIntl } from 'react-intl';

export const THEME_TOGGLE_TOUR_ELEMENT_ID = 'theme-toggle-btn';

/**
 * Runs the one-time tour for the sidenav theme toggle if not yet seen and before expiry.
 */
export function useThemeToggleTour(): TourHandle {
  const { $t } = useIntl();

  return useFeatureTour({ key: 'sidenavThemeToggle', expiry: '2026-07-30' }, {
    steps: [
      {
        element: `#${THEME_TOGGLE_TOUR_ELEMENT_ID}`,
        popover: {
          title: $t(
            defineMessage({
              id: 'core.sidenav.themeToggle.tour.title',
              defaultMessage: 'Modo oscuro disponible',
            }),
          ),
          description: $t(
            defineMessage({
              id: 'core.sidenav.themeToggle.tour.description',
              defaultMessage: 'Activá el modo oscuro desde aquí.',
            }),
          ),
          side: 'top',
          align: 'start',
        },
      },
    ],
  } satisfies TourConfig);
}
